<template>
  <div class="servizi text-xs-center pt-4">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <h1 color="primary" dark v-on="on">Servizi</h1>
      </template>
      <span>Trascina gli elementi per riposizionarli</span>
    </v-tooltip>
    
    <v-container>
      
      <!-- Ordina per...
      <v-layout row class="mb-4">
        <v-btn small flat color="grey" @click="sortBy('nome')">
          <v-icon left small>folder</v-icon>
          <span class="caption text-lowercase">Ordina per nome</span>
        </v-btn>
        <v-btn small flat color="grey" @click="sortBy('cognome')">
          <v-icon left small>folder</v-icon>
          <span class="caption text-lowercase">Ordina per cognome</span>
        </v-btn>
      </v-layout>
      -->
      <draggable
        :list="servizi"
        :disabled="!enabled"
        @start="dragging = true"
        @end="dragging = false" 
        @change="changed()"
      >

      <v-card flat class="pa-3 ma-2 servizi-folder" 
              v-for="(servizio, index) in servizi" 
              :key="servizio.index">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm6 md2 text-xs-center>
            <div class="caption grey--text mb-3">Nome servizio</div>
            <div>{{ servizio.nome }}</div>
          </v-flex>
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Effetto</div>
            <div>{{ servizio.effetto }}</div>
          </v-flex>
          <v-flex xs12 sm6 md2 text-xs-center>
            <div class="caption grey--text mb-3">Nota</div>
            <div>{{ servizio.nota }}</div>
          </v-flex> 
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Luxury</div>
            <div v-if="servizio.luxury" text-xs-center>Si</div>
            <div v-else>No</div>
          </v-flex> 
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-1">foto</div>
            <v-responsive>
              <v-avatar>
                <img :src="servizio.imageUrl" alt="">
              </v-avatar>
            </v-responsive>
          </v-flex>   
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Durata</div>
            <div> {{ servizio.durata }} </div>
          </v-flex>
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Prezzo</div>
            <div> {{ servizio.prezzo }} € </div>
          </v-flex>
          <v-flex xs12 sm6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Acconto</div>
            <div v-if="servizio.acconto" text-xs-center>Si</div>
            <div v-else>No</div>
          </v-flex>           

          <v-flex xs12 sm6 md1 text-xs-center>

            <template>
             
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn fab color="cyan" v-on="on" @click="modificaServizio(servizio.id, index)">
                      <v-icon dark>create</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Modifica {{nome}} {{effetto}}  </span>
                    </v-card-title>
                    <v-card-text>
                      <v-container> 

                        <v-flex text-xs-center class="mt-2">
                          <v-text-field 
                            label="Nome Servizio"
                            v-model="nome"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex text-xs-center>
                          <v-select
                            :items="effetti" 
                            v-model="effetto" 
                            label="Effetto" 
                          ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 text-xs-center class="mt-2">
                          <v-text-field 
                            label="Nota" 
                            v-model="nota">
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 text-xs-center>
                          <v-checkbox v-model="checkbox1" label="Luxury"></v-checkbox>
                        </v-flex>
              
                        <!-- <v-flex xs6 md2 text-xs-left>
                          <v-btn @click="onPickFile">Upload Image</v-btn>
                          <input type="file" 
                                style="display: none" 
                                ref="fileInput" 
                                accept="image/*" 
                                @change="onFilePicked"
                          >
                        </v-flex>

                        <v-flex xs6 md1 text-xs-left>
                          <img :src="servizio.imageUrl" height="50" width="50" alt="">
                        </v-flex> -->

                        <v-flex xs12 sm6 md6 text-xs-center>
                           <v-text-field 
                             label="Durata" 
                             type="time" 
                             v-model="durata">
                           </v-text-field>                                     
                        </v-flex>  

                        <v-flex xs12 sm6 md6 text-xs-center class="mt-2">
                          <v-text-field 
                            label="Prezzo" 
                            v-model.number="prezzo">
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm6 text-xs-center>
                          <v-checkbox v-model="acconto" label="Acconto"></v-checkbox>
                        </v-flex>                        

                        <v-flex xs12 text-xs-center>
                          <v-text-field 
                            label="Descrizione" 
                            v-model="descrizione">
                          </v-text-field>
                        </v-flex>
                    
                      </v-container>
        
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="salvaServizio(id)">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
          
            </template>

          </v-flex> 

          <v-flex xs12 sm6 md1 text-xs-center>
            <v-btn fab color="lash" @click="removeServizio(servizio.id, index)">
              <v-icon dark>delete</v-icon>
            </v-btn>
          </v-flex> 
        </v-layout>

      </v-card>

      <!-- FORM INSERIMENTO NUOV0 SERVIZIO -->
      <h2 class="my-5 heading">Inserisci un nuovo Servizio</h2>

      <v-form flat class="pa-3 ma-2 lashmaker-folder" ref="form">
        <v-layout row wrap>

          <v-flex xs12 sm6 md3 text-xs-center class="mt-2">
           <v-text-field label="Nome Servizio" solo flat v-model="nome"></v-text-field>
          </v-flex>  

          <v-flex xs12 sm6 md2 text-xs-center>
            <v-select
                    :items="effetti" 
                    v-model="effetto" 
                    label="Effetto" 
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6 md3 text-xs-center class="mt-2">
           <v-text-field label="Nota" solo flat v-model="nota"></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md1 text-xs-center>
            <v-checkbox v-model="checkbox1" label="Luxury"></v-checkbox>
          </v-flex>
 
          <v-flex xs6 md2 text-xs-left>
            <v-btn @click="onPickFile">Upload Image</v-btn>
            <input type="file" 
                   style="display: none" 
                   ref="fileInput" 
                   accept="image/*" 
                   @change="onFilePicked"
            >
          </v-flex>

          <v-flex xs6 md1 text-xs-left>
            <img :src="imageUrl" height="50" width="50" alt="">
          </v-flex>

          <v-flex xs12 sm6 md4 text-xs-center>
            <v-flex xs11 sm5>
            <v-dialog
              ref="dialog"
              v-model="modal2"
              :return-value.sync="durata"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="durata"
                  label="Durata"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="modal2"
                v-model="durata"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(durata)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
           <!-- <v-time-picker label="Durata" v-model="durata"></v-time-picker> -->
           
                 
          </v-flex>  

          <v-flex xs12 sm6 md2 text-xs-center class="mt-2">
           <v-text-field label="Prezzo" solo flat v-model.number="prezzo"></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md1 text-xs-center>
            <v-checkbox v-model="acconto" label="Acconto"></v-checkbox>
          </v-flex>          

          <v-flex xs12 text-xs-center>
           <v-text-field label="Descrizione" solo flat v-model="descrizione"></v-text-field>
          </v-flex>

        </v-layout>

        <v-btn dark class="lash" @click="submit" :loading="loading">INSERISCI</v-btn>

        <v-snackbar v-model="snackbar" :timeout="4000" color="success">
          <span>Servizio Aggiunto.</span>
          <v-btn flat color="white" @click="snackbar=false">Close</v-btn>
        </v-snackbar>

        <v-snackbar v-model="snackbar1" :timeout="4000" color="success">
          <span>Servizio Modificato.</span>
          <v-btn flat color="white" @click="snackbar1=false">Close</v-btn>
        </v-snackbar>

      </v-form>

      </draggable>
    </v-container>
  </div>
</template>

<script>
import fb from "@/fb"
import draggable from "vuedraggable"
export default {
  components: {
    draggable
  },  
  data() {
    return {
      menu2: false,
      modal2: false,
      servizi: [],
      nome: "",
      effetto: "",
      effetti:["Naturale", "Volume", "Ultramascara", "Laminazione"],
      nota: "",
      checkbox1: null,
      foto:"",
      imageUrl:"",
      durata: null, 
      prezzo: null,
      acconto: null,
      descrizione:"",
      loading: false,
      snackbar:  false,
      snackbar1:  false,
      dialog: false,
      id: null,
      indice: null,
      dragging: false,
      enabled: true,
      modifica: false
    }
  },
  methods: {
    /*checkMove: function(e) {
      this.indiceArrivo = e.draggedContext.futureIndex
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },*/    
    submit() {
      if ( this.$refs.form.validate() ) {
        // eslint-disable-next-line
        //console.log("inserita correttemente")
          this.loading = true
          const servizi = {
          nome : this.nome,
          effetto : this.effetto,
          nota : this.nota,
          luxury : this.checkbox1,
          imageUrl : this.imageUrl,
          durata : this.durata,
          prezzo : this.prezzo,
          acconto: this.acconto,
          descrizione : this.descrizione,
          indice : this.servizi.length
        }
        fb.db.collection("servizi").add(servizi).then(() => {
          //fb.storage.ref('Lashmaker/' + this.nome + this.cognome).put(this.image)
          this.nome = ""
          this.effetto = ""
          this.nota = ""
          this.checkbox1 = false
          this.imageUrl = ""
          this.durata = null
          this.prezzo = null
          this.acconto = null
          this.descrizione = ""
          this.loading = false
          this.snackbar = true
        })
      }   
    },
    removeServizio(id, index) {
      fb.db.collection('servizi').doc(id).delete()
      this.servizi.splice(index, 1)       
    },
    modificaServizio(id, index) {
      this.id = id
      this.indice = index
      this.nome = this.servizi[index].nome
      this.effetto = this.servizi[index].effetto
      this.nota =  this.servizi[index].nota,
      this.checkbox1 = this.servizi[index].luxury,
      this.durata = this.servizi[index].durata, 
      this.prezzo = this.servizi[index].prezzo,
      this.acconto = this.servizi[index].acconto,
      this.descrizione = this.servizi[index].descrizione
    },
    salvaServizio(id) {
      // Aggiorno collection
      fb.db.collection('servizi').doc(id).update({
        nome: this.nome,
        effetto: this.effetto,
        nota: this.nota,      
        checkbox: this.checkbox1,
        luxury: this.checkbox1,
        durata: this.durata,
        prezzo: this.prezzo,
        acconto: this.acconto,
        descrizione: this.descrizione
      })
      // Aggiorno array interno
      this.servizi[this.indice].nome = this.nome
      this.servizi[this.indice].effetto = this.effetto
      this.servizi[this.indice].nota = this.nota
      this.servizi[this.indice].luxury = this.checkbox1
      this.servizi[this.indice].durata = this.durata
      this.servizi[this.indice].prezzo = this.prezzo
      this.servizi[this.indice].acconto = this.acconto
      this.servizi[this.indice].descrizione = this.descrizione

      //svuoto campi
      this.nome = null
      this.effetto = null
      this.nota = null
      this.checkbox1 = null
      this.durata = null
      this.prezzo = null
      this.acconto = null
      this.descrizione = null
      
      // chiudo dialog
      this.dialog = false
      this.snackbar1 = true
    },    
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert("Please add a valid file!")
      }
      const fileReader = new FileReader()
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    },
    changed() {
      this.modifica = true
    }
  },
  beforeCreate() {
    fb.db.collection('servizi').orderBy('indice').onSnapshot(res => {
      const changes = res.docChanges()
      changes.forEach(change => {
        if (change.type === "added")  {
          this.servizi.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
  },
  beforeDestroy() {
    if (this.modifica) {
      let i = 0
      this.servizi.forEach(res => {  
        fb.db.collection('servizi').doc(res.id).update({
              indice : i
        }) 
        i = i + 1      
      }) 
    }
  }
}
</script>

<style>
.servizi-folder{border-left: 4px solid #FF9E80!important; border-bottom: 1px solid #dddddd!important;}

</style>

